<template>
    <vs-chip :transparent="true" class="ag-grid-cell-chip" :color="params.data.settingMedicalExaminationStep.medicalExaminationStep.color">
        <span>{{ params.data.settingMedicalExaminationStep.medicalExaminationStep.name}}</span>
    </vs-chip>
</template>

<script>
export default {
    name: "CellRendererStatus",
    computed: {
        // chipColor() {
        //     return value => {
        //         if (value.data.status === 1) {
        //             return "warning"
        //         } else if (value.data.status === 2) {
        //             return "complete"
        //         } else if (value.data.status === 3) {
        //             return "danger"
        //         }
        //     }
        // },
        // organizationStatusString() {
        //     return value => {
        //         if (value.data.status === 1) {
        //             return this.$t('menuNewFeed.wait')
        //         } else if (value.data.status === 2) {
        //             return this.$t('menuNewFeed.done')
        //         } else if (value.data.status === 3) {
        //             return this.$t('menuNewFeed.reject')
        //         }
        //     }
        // }
    }
}
</script>

<style scoped>

</style>
